import { supportsPassiveEvents } from 'detect-passive-events'

export { supportsPassiveEvents }

export let options = supportsPassiveEvents
  ? { capture: false, passive: true }
  : false
